import { makeStyles } from '@mui/styles'
import { MyAccountTheme, MyAccountCheckboxesClasses } from '@dxp-module/themes'

const checkboxesStyles = makeStyles<
  MyAccountTheme,
  object,
  MyAccountCheckboxesClasses
>(
  ({ breakpoints }) => ({
    root: {
      display: 'flex',
      [breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    itemRoot: {
      paddingRight: 0,
    },
    item: {
      paddingRight: 15,
    },
  }),
  { name: 'MyAccount_Checkboxes' }
)

export default checkboxesStyles
